import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CarouselComponent } from '@challenger/care/components/carousel/carousel.component';

@Component({
  selector: 'vm-advice',
  templateUrl: './advice.component.html',
  styleUrls: ['./advice.component.scss'],
})
export class AdviceComponent implements OnInit {
  @Input() backLabel = 'Back';
  @Input() items = [];
  @Output() carouselDone = new EventEmitter();
  @Output() carouselBack = new EventEmitter();
  @Output() carouselNext = new EventEmitter();
  @Output() carouselPrev = new EventEmitter();
  @Output() next = new EventEmitter();
  @Output() modalNext = new EventEmitter();
  currentSlideIndex;

  constructor(public carousel: CarouselComponent) {}

  ngOnInit(): void {
    this.currentSlideIndex = this.carousel.activeSlide;
  }

  onCarouselDone() {
    this.carouselDone.emit();
  }

  onCarouselBack() {
    this.carouselBack.emit();
  }

  onSlide(updatedSlideIndex) {
    if (updatedSlideIndex === this.currentSlideIndex + 1) {
      this.carouselNext.emit();
    } else if (updatedSlideIndex === this.currentSlideIndex - 1) {
      this.carouselPrev.emit();
    }
    this.currentSlideIndex = updatedSlideIndex;
  }

  onNext(id) {
    this.next.emit(id);
  }

  onModalNext(id) {
    this.modalNext.emit(id);
  }

  onBack(event) {
    history.back();
  }
}
